import app from 'flarum/common/app';

app.initializers.add('alwarithun-composer-mobile', () => {
  const vv = window.visualViewport;

  if (!vv || typeof vv.height !== 'number') {
    return;
  }

  // Matches Flarum's @phone breakpoint (max-width: 767.98px).
  const isPhone = () => window.matchMedia('(max-width: 767.98px)').matches;

  const apply = () => {
    const c = document.querySelector('.Composer');

    if (!c) return;

    const open = c.classList.contains('active') || c.classList.contains('fullScreen');

    // Only touch the height on phones while the composer is open and not
    // minimized; otherwise restore the theme's sizing.
    if (!isPhone() || !open || c.classList.contains('minimized')) {
      c.style.removeProperty('height');
      c.style.removeProperty('max-height');
      return;
    }

    // The composer is fixed to the top of the viewport on phones, so filling
    // it to visualViewport.height keeps it entirely above the virtual keyboard.
    c.style.setProperty('height', vv.height + 'px', 'important');
    c.style.setProperty('max-height', vv.height + 'px', 'important');
  };

  vv.addEventListener('resize', apply);
  vv.addEventListener('scroll', apply);

  // Re-apply when the composer opens, closes, goes full screen, or minimizes.
  const composer = document.querySelector('.Composer');
  if (composer) {
    new MutationObserver(apply).observe(composer, { attributes: true, attributeFilter: ['class'] });
  }

  apply();
});
